import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import useSelector from 'hooks/useSelector';
import { userHasPermission } from 'hooks/useRoles';
import { UserProfile } from 'shared/models/site/user-profile';
import { ExpandMore } from '@mui/icons-material';
import './FatigueAssessments.css'

import {
    fatigueAssessmentRoute,
    fatigueAssessmentBlankFormRoute,
    fatigueAssessmentOnBehalfRoute,
    fatigueAssessmentAssignRoute,
    fatigueAssessmentDashboardPathRoute,
    fatigueAssessmentPendingPathRoute,
    fatigueAssessmentActionPathRoute,
    fatigueAssessmentRevisitPathRoute,
    fatigueAssessmentCompletedPathRoute,
    fatigueAssessmentOverviewPathRoute
} from "components/portal/fatigueAssessment/FatigueAssessmentRoutes";

import {
    Label,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu
} from 'reactstrap';
import { ISelectOption } from '../forms/util';

const getFatigueAssessmentRoute = () => { return fatigueAssessmentRoute; }
const getFatigueAssessmentDashboardPathRoute = () => { return fatigueAssessmentDashboardPathRoute; }
const getFatigueAssessmentPendingPathRoute = () => { return fatigueAssessmentPendingPathRoute; }
const getFatigueAssessmentActionPathRoute = () => { return fatigueAssessmentActionPathRoute; }
const getFatigueAssessmentRevisitPathRoute = () => { return fatigueAssessmentRevisitPathRoute; }
const getFatigueAssessmentCompletedPathRoute = () => { return fatigueAssessmentCompletedPathRoute; }
const getFatigueAssessmentOverviewPathRoute = () => { return fatigueAssessmentOverviewPathRoute; }
const getFatigueAssessmentFormRoute = () => { return fatigueAssessmentBlankFormRoute; }
const getFatigueAssessmentOnBehalfRoute = () => { return fatigueAssessmentOnBehalfRoute; }
const getFatigueAssessmentAssignRoute = () => { return fatigueAssessmentAssignRoute; }

export const myForm = {
    label: "Pending",
    value: "myForm",
    getRoute: getFatigueAssessmentRoute
} as ISelectOption;

export const shiftSummaryDashboard = {
    label: "Shift Summary Dashboard",
    value: "shiftSummaryDashboard",
    getRoute: getFatigueAssessmentDashboardPathRoute
} as ISelectOption;

export const shiftSummaryDashboardPending = {
    label: "Pending Fatigue Assessments",
    value: "shiftSummaryDashboardPending",
    getRoute: getFatigueAssessmentPendingPathRoute,
    subitem: true
} as ISelectOption;

export const shiftSummaryDashboardToAction = {
    label: "Fatigue Assessments to action",
    value: "shiftSummaryDashboardToAction",
    getRoute: getFatigueAssessmentActionPathRoute,
    subitem: true
} as ISelectOption;

export const shiftSummaryDashboardToRevisit = {
    label: "Fatigue Assessments to revisit",
    value: "shiftSummaryDashboardToRevisit",
    getRoute: getFatigueAssessmentRevisitPathRoute,
    subitem: true
} as ISelectOption;

export const shiftSummaryDashboardCompleted = {
    label: "Completed - no action required",
    value: "shiftSummaryDashboardCompleted",
    getRoute: getFatigueAssessmentCompletedPathRoute,
    subitem: true
} as ISelectOption;


export const shiftSummaryDashboardOverview = {
    label: "Overview",
    value: "shiftSummaryDashboardOverview",
    getRoute: getFatigueAssessmentOverviewPathRoute,
    subitem: true
} as ISelectOption;


export const fatigueAssessmentForm = {
    label: "Form",
    value: "fatigueAssessmentForm",
    getRoute: getFatigueAssessmentFormRoute
} as ISelectOption;

export const fatigueAssessmentOnBehalf = {
    label: "On-behalf form",
    value: "fatigueAssessmentOnBehalf",
    getRoute: getFatigueAssessmentOnBehalfRoute
} as ISelectOption;

export const fatigueAssessmentAssign = {
    label: "Assign",
    value: "fatigueAssessmentAssign",
    getRoute: getFatigueAssessmentAssignRoute
} as ISelectOption;

interface FatigueAssessmentPageSelectorProps {
    selectedPage: ISelectOption
}

export const FatigueAssessmentPageSelector = (props: FatigueAssessmentPageSelectorProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const [selectOptions, setSelectOptions] = useState([props.selectedPage] as ISelectOption[]);
    const profile = useSelector(state => state.profile);
    const navigate = useNavigate();

    const getSelectOptions = (user: UserProfile) => {
        var options: ISelectOption[] = [];
        options.push(myForm);

        options.push(fatigueAssessmentForm);

        if (userHasPermission("web.admin.fatigue-assessment.on-behalf", user?.roles)) {
            options.push(fatigueAssessmentOnBehalf);
        }

        if (userHasPermission("web.admin.fatigue-assessment.shift-summary-dashboard", user?.roles)) {
            options.push(fatigueAssessmentAssign);
            options.push(shiftSummaryDashboard);
            options.push(shiftSummaryDashboardPending);
            options.push(shiftSummaryDashboardToAction);
            options.push(shiftSummaryDashboardToRevisit);
            options.push(shiftSummaryDashboardCompleted);
            options.push(shiftSummaryDashboardOverview);
        }

        return options;
    }

    const selectOnChange = (selectOption: ISelectOption) => {
        var path = selectOption.getRoute().path;
        if (selectOption !== currentSelection && typeof (path) === 'string') {
            navigate(path);
        }
    }

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(myForm);
        }

        if (profile && selectOptions.length <= 1) {
            setSelectOptions(getSelectOptions(profile));
        }
    }, [profile, selectOptions]);

    return (
        <div className="fatigue-assessments-selector fa-narrow">
            <UncontrolledDropdown>
                <DropdownToggle tag="div" className="rbt-input-main form-control rbt-input">
                    <div className="fa-select-options">{currentSelection.label}</div>
                </DropdownToggle>
                <ExpandMore />
                <DropdownMenu className="fa-page-selector">
                    {selectOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`form-check-inline dropdown-item ${ option.value }${ option.subitem ? ' sub-item' : '' }`}
                            onClick={() => selectOnChange(option)}>
                            <Label className={`form-check-label`}>{option.label}</Label>
                        </div>

                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );

}
